import { render, staticRenderFns } from "./Keterampilan.vue?vue&type=template&id=34423928&"
import script from "./Keterampilan.vue?vue&type=script&lang=js&"
export * from "./Keterampilan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports